<mat-button-toggle-group
  class="u-toggle-button-group {{ styleClass() }}"
  [disabled]="stateElement() === 'disabled'"
  [value]="selectedValue()"
  (change)="onChangeEvent($event)"
  [hideSingleSelectionIndicator]="true"
  [hideMultipleSelectionIndicator]="true"
>
  @for (option of options(); track option.value) {
    <mat-button-toggle [value]="option.value" [disabled]="option.disabled || stateElement() === 'disabled'">
      @if (option.label) {
        <span class="label">{{ option.label }}</span>
      }
    </mat-button-toggle>
  }
</mat-button-toggle-group>
